import type { Entry, TagLink } from 'contentful';

import type { ContentfulContentTypeEntry } from './useContentfulContentTypeEntries.types';

// ─── Entries ─────────────────────────────────────────────────────────────────

export function extractContentTypeEntryData<ContentTypeFields>(
  entry: Entry<ContentTypeFields>,
): ContentfulContentTypeEntry<ContentTypeFields> {
  return {
    fields: entry?.fields,
    tags: generateTagsIDsSet(entry.metadata.tags),
  };
}

// ─── Tags ────────────────────────────────────────────────────────────────────

/**
 * @see {@link https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags/querying-content-based-on-one-or-more-tags Querying content based on one or more tags}
 */
export function generateIncludedTagsParamEntry(tagsString: string | undefined) {
  if (!tagsString) return {};

  return { 'metadata.tags.sys.id[in]': tagsString };
}

export function generateTagsIDsSet(
  tags: readonly TagLink[],
): ReadonlySet<string> {
  return new Set(tags.map((tag) => tag.sys.id));
}
